import documentsLoader from './Home.loader'

export default async function loader(args) {
  return documentsLoader(args, true)
}
